import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

type Props = {
  children: ReactNode
  className?: string
  label?: string
  trailing?: ReactNode
}

export function FilterPanel({ children, className, label, trailing }: Props) {
  return (
    <div className={cn('dashboard-toolbar', className)}>
      {label ? (
        <span className="text-xs font-bold uppercase tracking-wider text-muted-foreground">{label}</span>
      ) : null}
      <div className="flex min-w-0 flex-1 flex-wrap items-end gap-4">{children}</div>
      {trailing ? <div className="flex shrink-0 flex-wrap items-center gap-2">{trailing}</div> : null}
    </div>
  )
}
